import { render, staticRenderFns } from "./FormExamination.vue?vue&type=template&id=10a0c86b&"
import script from "./FormExamination.vue?vue&type=script&lang=js&"
export * from "./FormExamination.vue?vue&type=script&lang=js&"
import style0 from "./FormExamination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports